import React, { Component } from "react";
import { message } from "antd";
import F from "../../../Functions";
import Bg from "../../LandingPage/images/bg.png";

const Print = () => {
  let tWindow = window.open("");
  if (tWindow) {
//     const PrintCSS = `
//             body {
//                 font-family: 'Roboto', sans-serif;
//             }
//             .bfileInfo {
//                 text-align: left;
//                 overflow: auto;
//                 margin-bottom: 20px;
//             }
//             a {
//                 color: #000;
//                 text-decoration: none;
//             }
//             button {
//                 display: none;
//             }
//             .bfileInfo h2 {
//                 margin: 0;
//             }
//             .bfileInfo .ant-avatar {
//                 float: left;
//             }
//             .bfileInfo .ant-avatar img {
//                 width: 90px;
//                 vertical-align: middle;
//                 margin-right: 20px;
//             }
//             #notes {
//                 display: none;
//             }
//             .cardBlue {
//                 width: 50%;
//                 float: left;
//             }
//             .cardBlue .ant-card-body {
//                 padding: 20px;
//             }
//             .cardBlue .ant-card-head {
//                 background: #1890ff;
//                 padding: 14px 20px;
//                 color: #FFF;
//                 font-weight: bold;
//             }
//             .ant-list-item {
//                 clear: both;
//                 padding: 10px 0;
//                 overflow: auto;
//                 border-bottom: 1px solid #E6E6E6;
//             }
//             .ant-list-item-meta-title {
//                 float: left;
//                 width: 50%;
//                 margin: 0;
//             }
//             .ant-list-item-meta-title + .ant-list-item-meta-description {
//                 float: left;
//                 width: 50%;
//             }
//             .ant-list-item img {
//                 width: 24px;
//                 height: auto;
//                 margin-right: 20px;
//                 vertical-align: middle;
//             }
//             .ant-list-item .ant-avatar img {
//                 width: 80px;
//             }
//             hr {
//                 display: block;
//                 clear: both;
//                 border: none;
//                 height: 20px;
//             }
//             /*                      Faizan Start                            */
// .spac {
//     margin: 0;
//     padding: 0;
//   }

//   .user-tab-one {
//     // width: 600px;
//     width: 100%;
//     // margin: auto;
//     font-family: "Roboto", sans-serif;
//     // background-color: yellow;
//   }

//   .user-tab-two {
//     // padding: 37px 40px 30px;
//     padding: 17px 20px 10px;
//     height: 142px;
//     // height: 40px;
//     background-position: bottom;
//     width: 100%;
//     background-color: red;
//   }

//   .user-tab-two td {
//     color: white;
//     border: none;
//   }

//   .user-tab-three {
//     width: 100%;
//   }

//   .user-tab-three td:first-child {
//     width: 104px;
//   }

//   .user-tab-three td:first-child img {
//     height: 90px;
//   }

//   .user-tab-three td:nth-child(2) {
//     vertical-align: top;
//   }

//   .randall {
//     font-size: 20px;
//     font-weight: bold;
//     margin: 0;
//     margin-bottom: 2.4px;
//   }

//   .email-wrap {
//     font-size: 14px;
//     margin: 0;
//     margin-bottom: 4px;
//   }

//   .icon-wrap {
//     margin-right: 6px;
//   }

//   .user-tab-two td:nth-child(2) {
//     vertical-align: top;
//   }

//   .user-tab-two td:nth-child(2) img {
//     margin-top: 6px;
//     width: 100px;
//   }

//   .user-tab-four {
//     width: 100%;
//   }

//   .user-tab-td {
//     vertical-align: top;
//     padding: 30px 20px;
//     width: 50%;
//   }

//   .status {
//     text-align: start;
//     font-size: 14px;
//     font-weight: bold;
//     padding-bottom: 4px;
//     color: #00152a;
//     border-bottom: 2px solid #00152a;
//   }

//   .user-td-one {
//     font-weight: bold;
//     border-bottom: solid 0.3px #979797;
//     width: 100%;
//   }

//   .user-tab-five {
//     width: 100%;
//     padding: 7px 0px;
//   }

//   .user-tab-five td:first-child {
//     font-size: 12px;
//     width: 50%;
//   }

//   .user-tab-five td:nth-child(2) {
//     font-size: 12px;
//     font-weight: normal;
//     text-align: end;
//   }

//   .user-tab-six {
//     padding-left: 20px;
//     padding-right: 20px;
//     width: 100%;
//   }

//   .user-tab-six td h3 {
//     font-size: 14px;
//     margin: 0;
//     text-align: center;
//     padding-bottom: 4px;
//     text-transform: uppercase;
//     color: #00152a;
//     border-bottom: 2px solid #00152a;
//   }

//   .user-td-two {
//     vertical-align: top;
//     padding: 20px;
//     width: 50%;
//   }

//   .user-tab-seven {
//     width: 100%;
//     height: 119px;
//   }

//   .user-tab-spac {
//     width: 100%;
//     padding: 7px 0px;
//   }

//   .user-tab-spac td:first-child {
//     font-size: 12px;
//   }

//   .user-tab-spac td:nth-child(2) {
//     font-size: 12px;
//     font-weight: normal;
//     text-align: end;
//   }

//   .user-tab-eight {
//     width: 100%;
//     padding: 7px 0px;
//   }

//   .user-tab-eight td:first-child {
//     font-size: 12px;
//     vertical-align: top;
//   }

//   .user-tab-eight td:nth-child(2) {
//     font-size: 12px;
//     font-weight: normal;
//     text-align: end;
//     width: 45%;
//   }

 
//   .pr-one {
//     margin-bottom: 0px;
//   }

//   .user-td-four {
//     vertical-align: top;
//     padding: 20px 18px;
//     width: 50%;
//   }

//   .user-tab-nine {
//     width: 100%;
//     padding: 7px 0px;
//   }

//   .user-tab-nine td:first-child {
//     font-size: 12px;
//   }

//   .user-tab-nine td:nth-child(2) {
//     font-size: 12px;
//     font-weight: normal;
//     text-align: end;
//     width: 60%;
//   }

//   .user-td-five {
//     font-weight: bold;
//     width: 100%;
//   }

//   .user-td-six {
//     font-size: 20px;
//     font-weight: bold;
//     padding-top: 16px;
//   }

//   .user-tab-ten {
//     width: 100%;
//     padding-top: 16px;
//   }

//   .user-td-seven {
//     font-size: 10px;
//     border-right: solid 0.3px #979797;
//     text-align: center;
//     width: 25%;
//   }

//   .user-tab-ten td:first-child img {
//     width: 50px;
//     padding-bottom: 5px;
//     // height: 100px;
//   }
//   .yes{
//     font-size: 10px;
//     text-align: center;
//     margin: 1px 10px 10px 0;
//   }

//   .user-tab-ten td:nth-child(2) img {
//     width: 40px;
//     padding-bottom: 5px;
//     height: 50px;
//   }

//   .user-tab-ten td:nth-child(3) img {
//     width: 40px;
//     padding-bottom: 5px;
//     height: 50px;
//   }

//   .user-tab-ten td:last-child {
//     font-size: 10px;
//     text-align: center;
//     width: 25%;
//   }

//   .user-tab-ten td:last-child img {
//     width: 40px;
//     height: 50px;
//     padding-bottom: 5px;
//   }

//   .user-tab-footer {
//     width: 100%;
//     margin-top: 120px;
//   }

//   // .user-tab-footer td {
//   //   height: 40px;
//   //   background-color: #00152a;
//   // }

//   .user-tab-one{
//     display: none;
//   }
//   @media print{
//       .hide-print{
//           display: none;
//         }
//     }
//     @media print {
//       .user-tab-one {display: block !important;}
//     }
//     .hk_bg{
//         background-color: #00152a;
//         // background-color: orange;
//         // width: 100% !important;
//         width: 700px;
//     }
// /*                      Faizan End                              */
//         `;
  const PrintCSS = `
        /* Basic CSS for styling */
        body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f4f4f4;
        }

        .page {
            width: 8.5in;
            height: 11in;
            margin: 0 auto;
            background: white;
            padding: 1in;
            box-sizing: border-box;
            border: 1px solid #ddd;
            position: relative;
            overflow: hidden;
        }

        .page:not(:last-child) {
            page-break-after: always;
        }

        .header {
            text-align: left;
            border-bottom: 2px solid #ddd;
            padding-bottom: 0.5rem;
            margin-bottom: 1rem;
        }

        .header img {
            height: 50px;
            float: left;
        }

        .header .agency {
            font-size: 1.2rem;
            margin-left: 60px;
        }

        .content {
            margin-top: 1rem;
        }

        .section {
            margin-bottom: 1rem;
            padding: 0.5rem;
            border: 1px solid #ddd;
            border-radius: 5px;
            background: #f9f9f9;
        }

        .footer {
            position: absolute;
            bottom: 1rem;
            left: 1in;
            font-size: 0.8rem;
        }
  `    
tWindow.document.write(
      '<html><head><title>Print it!</title><link href="https://fonts.googleapis.com/css?family=Roboto:300,400,700" rel="stylesheet"><style>' +
        PrintCSS +
        "</style></head><body>" +
        document.getElementById("landingPage").innerHTML +
        "</body></html>"
    );
    const elems = tWindow.document.querySelectorAll("[style]");
    for (var i = 0; i < elems.length; i++) {
      elems[i].removeAttribute("style");
    }
    const cards = tWindow.document.querySelectorAll(".cardBlue");
    for (var i = 0; i < cards.length; i++) {
      if (i > 0 && i % 2 === 0) {
        var element = cards[i];
        var newElement = document.createElement("hr");
        var elementParent = element.parentNode;
        elementParent.insertBefore(newElement, element);
      }
    }
    tWindow.document.close();
    tWindow.focus();
    setTimeout(function() {
      tWindow.print();
    }, 1000);
  } else {
    message.error(F.translate(`Please allow the popup in your browser.`));
  }
};

export default Print;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/print.js